import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
interface ResultsHeaderProps {
  step: number;
  total: number;
  onBack: () => void;
}
export function ResultsHeader({
  step,
  total,
  onBack
}: ResultsHeaderProps) {
  return <header className="pointer-events-none absolute inset-x-0 top-0 z-30 flex items-center gap-3 px-5 pt-5 md:pt-11" data-id="element-675" data-mp="q9x66bcc8ek7">
      <button type="button" onClick={onBack} aria-label="Go back" className="pointer-events-auto flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-navy-900/10 bg-white/85 text-navy-700 backdrop-blur-md transition hover:text-navy-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-teal" data-id="element-676" data-mp="10606rcrjk551">
        <ArrowLeftIcon className="h-4 w-4" data-id="element-677" data-mp="1538s1m7zkpai" />
      </button>
      <div className="grid flex-1 gap-1" style={{
      gridTemplateColumns: `repeat(${total}, minmax(0, 1fr))`
    }} role="progressbar" aria-label="Results progress" aria-valuemin={0} aria-valuemax={total} aria-valuenow={step} data-id="element-678" data-mp="3azctgwccll53">
        {Array.from({
        length: total
      }).map((_, i) => <div key={i} className="h-[3px] overflow-hidden rounded-full bg-navy-900/10" data-id="element-679" data-mp="2yd4p2prlhhaq" data-mpi={i}>
            <motion.div className="h-full rounded-full bg-navy-900" initial={false} animate={{
          width: i < step ? '100%' : '0%'
        }} transition={{
          duration: 0.5,
          ease: [0.22, 1, 0.36, 1]
        }} data-id="element-680" data-mp="33char76qcibq" />
          </div>)}
      </div>
    </header>;
}